import { render, staticRenderFns } from "./introDetailSet.vue?vue&type=template&id=2d305c5e&scoped=true&"
import script from "./introDetailSet.vue?vue&type=script&lang=js&"
export * from "./introDetailSet.vue?vue&type=script&lang=js&"
import style0 from "./introDetailSet.vue?vue&type=style&index=0&id=2d305c5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d305c5e",
  null
  
)

export default component.exports